module.exports = __webpack_public_path__ + "img/GBM1_Myofibroblasts.66b0cb6b.png";